import { useState, useMemo } from "react";
import { Link } from "react-router-dom";

import ModalTemplate from "../../../../common/modal/modalTemplate";
import ForgotPassword from "../../../../auth/signIn/components/ForgotPassword";
import SignInForm from "../../../../auth/signIn/components/SignInForm";
import { theme } from "../../../../theme";

const SignInModal = ({ show = false, closeModal }) => {
    const [showForgotPassword, setShowForgotPassword] = useState(false);

    const bodyContent = useMemo(() => (
        <div className="card ">
            <div className="card-header pb-0 text-left">
                <h5 className="">Welcome instafix</h5>
                <p className="mb-0">Enter your email and password to sign in</p>
            </div>
            <div className="card-body">
                {showForgotPassword ? <ForgotPassword setShowForgotPassword={setShowForgotPassword} /> : <SignInForm setShowForgotPassword={setShowForgotPassword} isCheckPrice={true}/> }
            </div>
            <div className="card-footer text-center pt-0 px-lg-2 px-1">
                <p className={`mb-4 text-sm mx-auto`}>
                    Don't have an account?
                    <Link to="/sign/up" className={`text-${theme.main} text-gradient font-weight-bold`}> Sign up</Link>
                </p>
            </div>
        </div>
    ), [showForgotPassword]);

    return (
        <ModalTemplate
            show={show}
            handleClose={closeModal}
            centered
            backdrop="static"
            keyboard={false}
            body={bodyContent}
            size="sm"
            isRemoveBodyPadding={true}
        />
    );
};

export default SignInModal;